'use client';
import e from 'prop-types';
import e__default, { useMemo } from 'react';
import { isNonNullish } from '../../../core/utilities/is.utils.js';
import { getSameKeyValueMapForManifest, manifestResolve } from '../../../core/utilities/manifest.utils.js';
import { useSwanHeadConfig } from './head.hook.js';
import { MANIFEST_STYLES } from '../../../core/manifest/styles.js';
import { SwanAssetFolders } from '../../../core/types/enums.js';
import { swanLoaderConfigProps } from '../../contexts/swan-provider/swan-provider.context.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
const SWAN_STYLE_KEY_MAP = getSameKeyValueMapForManifest(MANIFEST_STYLES);
let c = [
    SWAN_STYLE_KEY_MAP.core,
    SWAN_STYLE_KEY_MAP.utility,
    ...Object.keys(MANIFEST_STYLES).filter((e)=>e !== SWAN_STYLE_KEY_MAP.core && e !== SWAN_STYLE_KEY_MAP.utility)
];
const SWAN_STYLE_KEY_LIST = c;
function getSwanStylesheetUrl(e, t, r) {
    return manifestResolve(MANIFEST_STYLES, e, SwanAssetFolders.STYLES, t, r);
}
let p = _object_spread({
    styleSheetKeys: e.arrayOf(e.oneOf(SWAN_STYLE_KEY_LIST).isRequired)
}, swanLoaderConfigProps);
const SwanStylesheets = ({ styleSheetKeys: e = SWAN_STYLE_KEY_LIST, swanPathType: o, swanBaseUrl: n, swanTenant: _, swanLocale: l, renderWith: S = e__default.Fragment })=>{
    let { swanBaseUrl: c, swanPathType: p } = useSwanHeadConfig(n, o, _, l), a = useMemo(()=>{
        let t = new Set(e);
        t.delete(SWAN_STYLE_KEY_MAP.core), t.delete(SWAN_STYLE_KEY_MAP.utility);
        let r = Array.from(t);
        return r.sort(), r.unshift(SWAN_STYLE_KEY_MAP.core, SWAN_STYLE_KEY_MAP.utility), r.map((e)=>getSwanStylesheetUrl(e, p, c)).filter(isNonNullish);
    }, [
        e,
        p,
        c
    ]);
    return e__default.createElement(S, null, a.map((e)=>e__default.createElement("link", {
            rel: "stylesheet",
            href: e,
            key: e
        })));
};
SwanStylesheets.propTypes = p;

export { SWAN_STYLE_KEY_LIST, SWAN_STYLE_KEY_MAP, SwanStylesheets, getSwanStylesheetUrl };
